/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Configuration promotion info
 */
export interface PromotionInfo {
  promotionCode?: string;
  promotionWelcomeImage?: string;
  promotionSpecialImage?: string;
}
